import { SPACING_PRIMITIVE as x } from "./index.es2362.js";
const s = {
  xxxs: x[2],
  xxs: x[4],
  xs: x[6],
  s: x[8],
  md: x[12],
  lg: x[16],
  xl: x[24],
  "2xl": x[32],
  "3xl": x[40],
  "4xl": x[48]
};
export {
  s as SPACINGS
};
//# sourceMappingURL=index.es650.js.map
